import { QuestionCircleTwoTone } from "@ant-design/icons";
import { Link } from "react-router-dom";
import styles from "./HelpButton.module.scss";

export interface HelpButtonProps {
  url: string;
  type?: string;
  children?: React.ReactNode;
  size?: string;
}

export default function HelpButton({ url, children, ...props }: HelpButtonProps) {
  return (
    <Link
      to={url}
      target="_blank"
      className={styles.HelpButton}
    >
      <QuestionCircleTwoTone />
      <span>{children || "How it works"}</span>
    </Link>
  );
}
